import BaseService from '@root/core/class/BaseService';

class buskService extends BaseService {
  public getListSeller = (
    page: number,
    fromDt?: string,
    toDt?: string,
    filterState?: string,
    filter?: string,
    input?: string,
    sort?: boolean
  ) => {
    const inputEncode = input?.replaceAll('%', '%25').replaceAll('#', '%23');

    return this.get(
      `/sellers?page=${page}&limit=10${
        Boolean(filterState) ? '&filterBy=state:' + filterState : '&filterBy='
      }${Boolean(input) ? '&search=' + inputEncode : '&search='}${
        Boolean(fromDt) ? '&fromDt=' + fromDt : '&fromDt='
      }${Boolean(toDt) ? '&toDt=' + toDt : '&toDt='}${
        Boolean(filter) ? '&searchBy=' + filter : '&searchBy='
      }${Boolean(!sort) ? '&sortBy=created_at:DESC' : '&sortBy=created_at:ASC'}`
    );
  };

  public exportSellerExcell = (
    page: number,
    fromDt?: string,
    toDt?: string,
    state?: string,
    filter?: string,
    input?: string,
    sort?: boolean
  ) => {
    const inputEncode = input?.replaceAll('%', '%25').replaceAll('#', '%23');

    return this.post(
      `/sellers/export?page=${page}&${
        Boolean(state) ? '&filterBy=state:' + state : '&filterBy='
      }${Boolean(input) ? '&search=' + inputEncode : '&search='}${
        Boolean(fromDt) ? '&fromDt=' + fromDt : '&fromDt='
      }${Boolean(toDt) ? '&toDt=' + toDt : '&toDt='}${
        Boolean(filter) ? '&searchBy=' + filter : '&searchBy='
      }${
        Boolean(!sort) ? '&sortBy=updated_at:DESC' : '&sortBy=updated_at:ASC'
      }`,
      {},
      {
        responseType: 'blob'
      }
    );
  };

  public exportSellerExcellById = (listId: any) => {
    return this.post(
      `/sellers/export`,
      {
        ids: listId
      },
      {
        responseType: 'blob'
      }
    );
  };
}

export default new buskService('/api/v1/admin', true);
